<!--
 * @Descripttion: 促销活动,秒杀
 * @version:
 * @Author: xuzhongqi
 * @Date: 2022-01-10
 * @LastEditors: xuzhongqi
 * @LastEditTime: 2022-01-10
-->
<template>
  <div>
    <div class="model">
      <iHeader />
      <iNav />
      <iClassify
        :active="3"
        all-active
      />
      <iRightFixedBox />

      <!-- banner -->
      <div class="banner-view">
        <div class="notice-model">
          <img
            :src="bannerUrl"
            fit="cover"
            class="notice"
          >
        </div>
        <div class="mask-model" />
      </div>
      <!-- banner end -->

      <!-- body -->
      <div class="body-view">
        <div class="box">

          <!-- banner 下方秒杀倒计时部分 -->
          <div v-if="searchStyleType === 'seckill'" class="seckill-view">
            <div class="seckill-timer-view">
              <div class="seckill-timer-bg-view">
                <van-count-down
                  class="search-count-view"
                  :time="times"
                >
                  <template #default="timesData">
                    <span>
                      <img
                        src="../../assets/fire.png"
                        fit="cover"
                        class="search-count-lcon"
                      >
                    </span>
                    <span>距离活动结束剩余</span>
                    <span class="search-count-timer">{{ prefixInteger(timesData.days,2) }}天</span>
                    <span>:</span>
                    <span class="search-count-timer">{{ prefixInteger(timesData.hours,2) }}时</span>
                    <span>:</span>
                    <span class="search-count-timer">{{ prefixInteger(timesData.minutes,2) }}分</span>
                    <span>:</span>
                    <span class="search-count-timer">{{ prefixInteger(timesData.seconds,2) }}秒</span>
                    </span></template>
                </van-count-down>
              </div>
            </div>
            <div class="seckill-text-view">
              *特别说明 ：本场秒杀最多可选购{{ Species }}个品类
            </div>
          </div>
          <!-- banner 下方秒杀倒计时部分 end -->

          <div class="table-view">

            <!-- 活动结束倒计时，条件筛选组件部分 -->
            <el-row
              v-if="isTimes"
              :gutter="20"
              class="search-view"
              :class="{ 'fixed-search-view' : isFixedMenu, 'fixed-search-seckill-view' : searchStyleType === 'seckill' }"
            >

              <el-col :span="24">
                <div class="grid-content">
                  <!-- 搜索组件 -->
                  <Search
                    ref="Search"
                    :is-fixed-menu="isFixedMenu"
                    :search-style-type="searchStyleType"
                    @on-trigge="search"
                  />
                </div>
              </el-col>
            </el-row>
            <!-- 活动结束倒计时，条件筛选组件部分 end -->

            <!-- list -->
            <div class="list-box" :class="{ 'list-seckill-box' : searchStyleType === 'seckill' }">
              <div v-for="(item, index) in defaultData" :key="index" class="flex">
                <!-- list 组件(普通活动样式，适用于宫格) -->
                <NewProductItem ref="NewProductItem" :product="item" />
              </div>
            </div>
            <!-- list end -->

            <template v-if="defaultData.length === 0">
              <EmptyControl
                style="margin: 20px 0; padding: 100px 0;"
                type="no-data"
                show-new-goods-collect
              />
            </template>

          </div>

          <div class="page-view">
            {{ IsHasNext ? '向下拉展示更多商品' : '所有商品均已加载完毕' }}
          </div>

        </div>
      </div>
      <!-- body end -->

      <iFooter />
    </div>
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iRightFixedBox from '@/components/RightFixedBox'
import iFooter from '@/components/Footer'
import { BaseMixin } from '@/mixins/BaseMixin'
import Search from './components/search.vue'
import NewProductItem from '../storey/NewProductItem.vue'
export default {
  name: 'ActivityView',
  components: {
    iHeader,
    iNav,
    iClassify,
    iRightFixedBox,
    iFooter,
    Search,
    NewProductItem
  },
  mixins: [BaseMixin],
  data() {
    return {
      // 倒计时
      times: 9999999,
      // 是否展示倒计时标记,默认false
      isTimes: true,
      // 搜索menu是否需要固定标记,默认false
      isFixedMenu: false,
      // 搜索组件样式类型, 传seckill代表秒杀，传空代表其余的活动板块
      searchStyleType: 'seckill',
      // 搜索条件
      searchData: {
        // 活动ID
        SalesPromotionId: '',
        // 秒杀Id（如果该字段传了值，则查询秒杀活动数据，传空则根据classId 来查询相关活动）
        SeckillId: '',
        // 模糊查询关键字
        Keyword: '',
        // 排序类型 0综合排序 1价格 2销量 3分类（3仅是前端使用，接口用不到）
        SortType: 0,
        // 排序模式，是否正序，如果选择综合排序，则该参数会传空
        IsSortAsc: true,
        // 分类ID
        ClassIds: '',
        // 分页标记，由后端返回，第一次第一页，前端默认传递0 （偏移量）
        Offset: 0,
        // 活动大类
        Type: '',
        // 活动单独小类
        ActivityType: ''
      },
      // 是否分页标记,后端返回
      IsHasNext: false,
      // 计时器(节流延时跳转，避免快速加载)
      timer: null,
      // banner背景图
      bannerUrl: '',
      // 剩余品种展示
      Species: 0,
      // 数据
      defaultData: []
    }
  },
  mounted() {
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  created() {
    // 外部跳转传入的秒杀活动ID
    if (this.$route.query.id) {
      this.searchData.SalesPromotionId = this.$route.query.id
      // 初始化获取时间戳，banner图
      this.getActivityInfo()
    } else {
      this.$toast.fail('无秒杀活动ID')
    }
  },
  methods: {
    /*
     * 初始化获取所有活动大类
     */
    async getActivityInfo() {
      // 获取活动分类
      const res = await this.getAction(
        '/api_promotions/PromotionActivities/GetActivityInfo',
        {
          id: this.searchData.SalesPromotionId
        }
      )
      if (!res.IsSuccess) {
        this.$toast.fail(res.Msg)
        return
      }
      if (res.IsSuccess && res.Data.length === 0) {
        this.$toast.fail('暂无活动数据')
        return
      }
      // 请求成功
      // 初始化获取list
      this.getSeckillList()

      // 获取时间戳，判断是否需要展示活动倒计时
      this.isTimeVerification(res.Data.TimeStamp)
      // 设置背景图
      this.bannerUrl = res.Data.PcImgUrl
      // 剩余品种展示
      this.Species = res.Data.Species
    },
    /*
     * 验证是否需要显示活动倒计时
     *  @param time {int} 时间戳
     */
    isTimeVerification(time) {
      // 获取时间戳，判断是否需要展示活动倒计时
      if (time !== null) {
        this.times = time
        this.isTimes = true
      } else {
        this.times = 0
        this.isTimes = false
      }
    },
    /*
     * 数字补0方法
     * @param num {number} 需要转换的数值
     * @param size {number} 需要转换的数值长度
     * @return 补0后的数值
     */
    prefixInteger(num, size) {
      return (Array(size).join(0) + num).slice(-size)
    },
    /*
     * 搜索组件回调方法
     * @param param {object} 搜索条件对象
     */
    search(param) {
      // 缓存搜索条件
      // 模糊查询关键字
      this.searchData.Keyword = param.Keyword
      // 排序类型 0综合排序 1价格 2销量 3分类（3仅是前端使用，接口用不到）
      this.searchData.SortType = param.SortType
      // 排序模式，是否正序，如果选择综合排序，则该参数会传空
      this.searchData.IsSortAsc = param.IsSortAsc
      // 分类ID
      this.searchData.ClassIds = param.ClassId
      // 重置标记
      this.searchData.Offset = 0
      // 初始化查询必要参数
      this.initSearchData()
      // 获取list
      this.getSeckillList()
    },
    /*
     * 初始化查询条件
     */
    initSearchData() {
      // 搜索条件
      this.searchData.Offset = 0
      this.IsHasNext = false
      // 清空table
      this.defaultData = []
      // 初始化计时器对象
      this.timer = null
    },
    /*
     * 获取列表方法
     */
    async getSeckillList() {
      // 开启加载层
      this.$hys.openLoading()
      // 获取列表
      const res = await this.getAction(
        '/api_goods/GoodsSku/ListForCustomerV3',
        this.searchData
      )
      if (!res.IsSuccess) {
        this.$toast.fail(res.Msg)
        // 关闭加载层
        this.$hys.clearLoading()
        return
      }
      if (res.IsSuccess && res.Data.GoodsList.length === 0 && this.defaultData.length === 0) {
        // this.$toast.fail('暂无活动数据')
        // 关闭加载层
        this.$hys.clearLoading()
        // 初始化查询必要参数
        this.initSearchData()
        return
      }
      if (res.IsSuccess && res.Data.GoodsList.length === 0 && this.defaultData.length !== 0) {
        // this.$toast.fail('暂无活动数据')
        // 关闭加载层
        this.$hys.clearLoading()
        return
      }

      // 追加到本地数据集合中
      res.Data.GoodsList.forEach((item) => {
        this.defaultData.push(item)
      })
      // 本地数据集合通过ID去重
      this.defaultData = this.defaultData.filter(function(
        element,
        index,
        self
      ) {
        return self.findIndex((el) => el.Id === element.Id) === index
      })

      // 关闭加载层
      this.$hys.clearLoading()
      // 保存分页标记，由后端返回，第一次第一页，前端默认传递0 （偏移量）
      this.searchData.Offset = res.Data.Offset
      // 保存是否分页标记
      this.IsHasNext = res.Data.IsHasNext
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录
      if (scrollTop > 600) {
        this.isFixedMenu = true
      } else {
        this.isFixedMenu = false
      }

      // 到达页面底部时
      if ((scrollTop + clientHeight >= scrollHeight - 400) && this.IsHasNext) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        // 开启加载层
        this.$hys.openLoading()
        this.IsHasNext = false
        // 延时请求
        this.timer = setTimeout(() => {
          // 获取list
          this.getSeckillList()
        }, 100)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/activityView.less");
</style>
